import './HorizontalDivider.css';

interface Props{
    className? : string;
}

export function HorizontalDivider(props : Props){
    return <div className={`divider ${props.className ? props.className : ""}`}/>
}